import { FUND_DOCUMENTS_HEADER_TYPES_MATCHING } from '../../constants';

export const createLinkAndDownloadDoc = async (res: Response) => {
  const filename = res.headers.get('content-disposition').split('filename=')[1];
  const blob = await res.blob();
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.download = decodeURI(filename);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getMappedFundDocumentHeaderValue = (value: string) => {
  return FUND_DOCUMENTS_HEADER_TYPES_MATCHING[value];
};
